module.exports = __webpack_public_path__ + "static/cercazone_nordovest2-f80d96b7f9141cffb592dfba0df45f92.jpg";